import DOMPurify from "dompurify";

/** Whitelist alinhada à decisão produto § 22.3 — negrito + listas em `/units`. */
const ALLOWED_TAGS = ["p", "br", "b", "strong", "ul", "ol", "li"];

export const sanitizeRichTextHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: [],
  });

export const richTextPreviewPlain = (html: string): string =>
  sanitizeRichTextHtml(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
